var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2167 0.500002C18.9183 0.500168 17.6448 0.855791 16.5343 1.52831C15.4237 2.20082 14.5184 3.16456 13.9167 4.315C13.1773 2.90775 11.988 1.78856 10.5385 1.1359C9.08898 0.483236 7.46268 0.334678 5.9189 0.71391C4.37513 1.09314 3.00277 1.97833 2.02064 3.22833C1.03852 4.47833 0.503187 6.02116 0.5 7.61084C0.5 11.5367 2.93833 15.1242 6.08833 18.07C8.51846 20.2235 11.1386 22.1525 13.9167 23.8333C16.6739 22.1215 19.2915 20.1944 21.745 18.07C25.245 14.8733 27.3333 11.5367 27.3333 7.61084C27.3333 6.67654 27.1492 5.7514 26.7915 4.88829C26.4338 4.02518 25.9095 3.24103 25.2486 2.58065C24.5876 1.92028 23.8031 1.39662 22.9397 1.03961C22.0763 0.682598 21.151 0.499236 20.2167 0.500002Z",
    stroke: "#121212",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.15d27131021795f95696195074740d64.svg";
export { ForwardRef as ReactComponent };